import { Card, CardContent, CardHeader } from '@material-ui/core';

const DashboardUAT = () => (
    <Card>
        <CardHeader title="Ride Modes UAT" />
        <CardContent>Click on the Ride Modes tab on the left to modify the UAT environment ride modes configuration.</CardContent>
    </Card>
);

export default DashboardUAT;